<template>
	<div class="full box">
		<el-button type="primary">占位</el-button>
		<el-button type="success">占位</el-button>
		<el-button type="info">占位</el-button>
		<el-button type="warning">占位</el-button>
		<el-button type="danger">占位</el-button>
	</div>
</template>
<style scoped>
	.box {
		box-sizing: border-box;
		padding: 20px 10px;
		overflow: auto;
	}

	.item {
		flex-direction: row;
		align-items: center;
	}
</style>
<script>
	export default {
		name: 'reportIndex',
		props: {

		},
		data() {
			return {
				like: true,
				value1: 4154.564,
				value2: 2222,
				title: '今年的增长',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			handleChange() {

			}
		},
		components: {

		}
	}
</script>
